// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1396b03","link":"_1610d58"};